import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LocalStoreKeys } from 'src/app/shared/helpers/localstorage/local-store';
import { GrantType } from 'src/app/shared/enums/grant-type.enum';
import { Router } from '@angular/router';
import { v4 as uuid } from 'uuid';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  ngOnInit() {
    if (this.authenticationService.currentUserValue === null) {
      localStorage.setItem(LocalStoreKeys.uuid, uuid());

      this.authenticationService.registry(localStorage.getItem(LocalStoreKeys.uuid), null, GrantType.Gestor).subscribe(
        response => {
          if (response.status === ApiError.Sucesso) {
            response.result.isAnonymous = true;
            this.authenticationService.setCurrentUserRegistryValue(response.result);
          } else
            this.router.navigate(['']);
        }
      );
    }
  }
}
